
import { AggregatedSessionV2 } from "@global/types/session";

/** Get page flow from pageSessions */
export function getPageFlow(session: AggregatedSessionV2): string[] {
  return session.pageSessions.map((ps) => ps.pagePath);
}

/** Get page views count from pageSessions */
export function getPageViewsCount(session: AggregatedSessionV2): number {
  const pages = new Set(session.pageSessions.map((ps) => ps.pagePath));
  return pages.size;
}

/** Get session duration in seconds */
export function getSessionDuration(session: AggregatedSessionV2): number {
  return (session.sessionEnd - session.sessionStart) / 1000;
}

/** Format duration from milliseconds */
export function formatDuration(ms: number): string {
  const secs = ms / 1000;
  if (secs < 60) return `${secs.toFixed(1)}s`;
  return `${Math.floor(secs / 60)}m ${Math.round(secs % 60)}s`;
}

/** Format duration from seconds for table display */
export function formatDurationSeconds(secs: number): string {
  if (secs == null || secs === 0) return "-";
  if (secs >= 3600) return `${(secs / 3600).toFixed(1)}h`;
  if (secs >= 60) return `${Math.floor(secs / 60)}m ${Math.round(secs % 60)}s`;
  return `${Math.round(secs)}s`;
}

/** Get unique experiments from page sessions */
export function getExperiments(
  session: AggregatedSessionV2
): { experimentId: string; variantId: string }[] {
  const seen = new Set<string>();
  const experiments: { experimentId: string; variantId: string }[] = [];

  for (const ps of session.pageSessions) {
    if (ps.experimentId) {
      const key = `${ps.experimentId}:${ps.variantId || "control"}`;
      if (!seen.has(key)) {
        seen.add(key);
        experiments.push({
          experimentId: ps.experimentId,
          variantId: ps.variantId || "control",
        });
      }
    }
  }

  return experiments;
}
